import React from 'react';

const Contact2 = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-5 col-md-12">
                    <h3 className="sec_large_title">
                        Visit any of Our Brunch & Have a great Culinary Experience
                    </h3>
                </div>
                <div className="col-lg-7 col-md-12">
                    <div className="keepintouch">
                        <div className="communication">
                            <div className="info_body">
                                <h5>New Yourk</h5>
                                <p>
                                    112/9 Madison Park, New York <br />
                                    hungrybuzz.ny@gmail.com<br />
                                    +33 123 456 789 (hungry)
                                </p>
                            </div>
                        </div>
                        <div className="communication">
                            <div className="info_body">
                                <h5>California</h5>
                                <p>
                                    112/9 Madison Park, New York <br />
                                    hungrybuzz.ny@gmail.com<br />
                                    +33 123 456 789 (hungry)
                                </p>
                            </div>
                        </div>
                        <div className="communication">
                            <div className="info_body">
                                <h5>Utah</h5>
                                <p>
                                    112/9 Madison Park, New York <br />
                                    hungrybuzz.ny@gmail.com<br />
                                    +33 123 456 789 (hungry)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact2;